import LaddaButton, { SLIDE_UP, XL } from 'react-ladda';
import React, { useEffect, useState } from 'react';
import { env } from '../../../env';
import moment from 'moment';
import { Observer } from 'mobx-react';
import { SingleDatePicker } from 'react-dates';
import { Tooltip } from 'react-tippy';


const StaffWeekend = () => {

  const [updatedWeekend, setUpdatedWeekend] = useState();
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState();
  const [userWeekends, setUserWeekends] = useState([]);
  const [isUpdateDatePickerOpen, setUpdateDatePickerOpen] = useState([]);

  const handleUpdateDatePickerOpen = (weekendId) => {
    if (isUpdateDatePickerOpen.includes(weekendId)) {
      setUpdateDatePickerOpen(isUpdateDatePickerOpen.filter(id => id !== weekendId));
    } else {
      setUpdateDatePickerOpen([...isUpdateDatePickerOpen, weekendId]);
    }
  };

  const handleWeekendAdd = async () => {
    if (!selectedDate) return env.alert('Ошибка', `Пожалуйста выберите дату выходного дня`);

    try {
      const data = await env.http
        .post('staff/profile/weekend', {
          weekendDate: selectedDate
        })
        .then(response => response.data);
      setUserWeekends(data);
      env.alert('Успех', `Данные успешно сохранены`);
    } catch (e) {
      console.log(e);
      env.alert('Ошибка', `Ошибка. Данные не сохранились.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`);
    }
  };

  const handleWeekendDelete = async (weekendId) => {
    try {
      const data = await env.http
        .delete(`staff/profile/weekend/${weekendId}`)
        .then(response => response.data);
      setUserWeekends(data);
      env.alert('Успех', `Данные успешно удалены`);
    } catch (e) {
      console.log(e);
      env.alert('Ошибка', `Ошибка. Данные не удалились.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`);
    }
  };

  const onDateChange = event => {
    setSelectedDate(moment(event._d));
  };

  const onEditWeekendChange = (weekendId) => {
    if (weekendId !== updatedWeekend) {
      setUpdatedWeekend(weekendId);
      setSelectedDate(moment(userWeekends.find(weekend => weekend.id === weekendId).day, 'YYYYMMDD'));
    } else {
      setUpdatedWeekend(null);
      setSelectedDate(null);
    }
  };

  const handleWeekendUpdate = async (weekendId) => {
    try {
      const data = await env.http
        .patch(`staff/profile/weekend`, {
          weekendDate: selectedDate, weekendId: weekendId
        })
        .then(response => response.data);
      setUserWeekends(data);
      setUpdatedWeekend(null);
      setSelectedDate(null);
      setUpdateDatePickerOpen(isUpdateDatePickerOpen.filter(id => id !== weekendId));
      env.alert('Успех', `Данные успешно обновлены`);
    } catch (e) {
      console.log(e);
      env.alert('Ошибка', `Ошибка. Данные не обновились.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`);
    }
  };

  const handleWeekendDuplicate = async (weekendId) => {
    try {
      const data = await env.http
        .post(`staff/profile/weekend/duplicate/${weekendId}`)
        .then(response => response.data);
      setUserWeekends(data);
      setUpdatedWeekend(null);
      setSelectedDate(null);
      setUpdateDatePickerOpen(isUpdateDatePickerOpen.filter(id => id !== weekendId));
      env.alert('Успех', `Выходной успешно продублирован на протяжении 3 месяцев`);
    } catch (e) {
      console.log(e);
      env.alert('Ошибка', `Ошибка. Данные не обновились.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`);
    }
  };

  const handleWeekendCancel = (weekendId) => {
    setUpdatedWeekend(null);
    setSelectedDate(null);
    setUpdateDatePickerOpen(isUpdateDatePickerOpen.filter(id => id !== weekendId));
  };

  const getUserWeekends = () => {
    env.http.get('staff/profile/weekend').then(response => {
      setUserWeekends(response.data);
    });
  };

  useEffect(() => {
    getUserWeekends();
  }, []);


  return (<>
      <div className='profile-page__headline-title profile-page__headline-title-change-password'>
        Выбрать выходной
      </div>
      <div>
        <h3>Ближайшие выходные :</h3>
        {userWeekends.map((weekend, index) => (<div key={index} style={{ display: 'flex', alignItems: 'center' }}>
            <p key={index}>{moment(weekend.day, 'YYYYMMDD').format('DD.MM.YYYY')}</p>
            {(updatedWeekend !== weekend.id) && (<>
                <button
                  className='popup__btn popup__btn_cancel js-popup-edit-cancel'
                  onClick={() => handleWeekendDelete(weekend.id)}
                >
                  <svg
                    className='icon icon-cancel'
                    id='icon-cancel'
                    viewBox='0 0 15.5 15.5'
                    width='100%'
                    height='100%'
                  >
                    <path
                      d='M7.75.25A7.5 7.5 0 0 0 2.31 2.6l-.03.02A7.45 7.45 0 0 0 .25 7.75a7.5 7.5 0 1 0 7.5-7.5zm-6.29 7.5c0-1.43.48-2.75 1.29-3.81l8.81 8.81a6.3 6.3 0 0 1-10.1-5zm10.98 4.17L3.58 3.06a6.3 6.3 0 0 1 8.86 8.86z' />
                    <path
                      strokeMiterlimit='50'
                      strokeWidth='.5'
                      d='M7.75.25A7.5 7.5 0 0 0 2.31 2.6l-.03.02A7.45 7.45 0 0 0 .25 7.75a7.5 7.5 0 1 0 7.5-7.5zm-6.29 7.5c0-1.43.48-2.75 1.29-3.81l8.81 8.81a6.3 6.3 0 0 1-10.1-5zm10.98 4.17L3.58 3.06a6.3 6.3 0 0 1 8.86 8.86z'
                    />
                  </svg>
                </button>
                <button className='popup__btn popup__btn_edit js-popup-edit'
                        onClick={() => onEditWeekendChange(weekend.id)}>
                  <svg
                    className='icon icon-pencil-black'
                    id='icon-pencil'
                    viewBox='0 0 15 15'
                    width='100%'
                    height='100%'
                  >
                    <path
                      d='M8.71 2.34l2.84 2.86-7.21 7.24L1.5 9.58zm5 .69L12.3 4.45 9.45 1.59 10.66.37c.5-.49 1.29-.49 1.78 0l1.27 1.28c.39.38.39 1 0 1.38zM.01 13.6c-.05.24.16.45.39.39l3.17-.77-2.84-2.86z' />
                  </svg>
                </button>
              </>)}
            {(updatedWeekend === weekend.id) && (<Observer>
                {() => (<>
                    <div className='picker-wrapper'>
                      <SingleDatePicker
                        block
                        isOutsideRange={() => false}
                        placeholder='Виберите дату'
                        focused={isUpdateDatePickerOpen.includes(weekend.id)}
                        date={selectedDate}
                        onDateChange={onDateChange}
                        onFocusChange={() => handleUpdateDatePickerOpen(weekend.id)}
                      />
                    </div>

                    <button
                      className='popup__btn popup__btn_save js-popup-edit-save'
                      onClick={() => handleWeekendUpdate(weekend.id)}
                    >
                      <svg
                        className='icon icon-like'
                        id='icon-like'
                        viewBox='0 0 14.53 10'
                        width='100%'
                        height='100%'
                      >
                        <path
                          d='M12.74 1.18a.6.6 0 0 0-.86 0L4.6 8.46l-2.8-2.8a.62.62 0 0 0-.86 0 .6.6 0 0 0 0 .86l3.23 3.23a.6.6 0 0 0 .86 0l7.71-7.71a.6.6 0 0 0 0-.86z' />
                        <path
                          strokeMiterlimit='50'
                          strokeWidth='2'
                          d='M1239.98 296.18a.6.6 0 0 0-.86 0l-7.28 7.28-2.8-2.8a.62.62 0 0 0-.86 0 .6.6 0 0 0 0 .86l3.23 3.23a.6.6 0 0 0 .86 0l7.71-7.71a.6.6 0 0 0 0-.86z'
                          clipPath='url(&quot;#a&quot;)'
                          transform='translate(-1227.24 -295)'
                        />
                      </svg>
                    </button>

                    <button
                      className='popup__btn popup__btn_cancel js-popup-edit-cancel'
                      onClick={() => handleWeekendCancel(weekend.id)}
                    >
                      <svg
                        className='icon icon-cancel'
                        id='icon-cancel'
                        viewBox='0 0 15.5 15.5'
                        width='100%'
                        height='100%'
                      >
                        <path
                          d='M7.75.25A7.5 7.5 0 0 0 2.31 2.6l-.03.02A7.45 7.45 0 0 0 .25 7.75a7.5 7.5 0 1 0 7.5-7.5zm-6.29 7.5c0-1.43.48-2.75 1.29-3.81l8.81 8.81a6.3 6.3 0 0 1-10.1-5zm10.98 4.17L3.58 3.06a6.3 6.3 0 0 1 8.86 8.86z' />
                        <path
                          strokeMiterlimit='50'
                          strokeWidth='.5'
                          d='M7.75.25A7.5 7.5 0 0 0 2.31 2.6l-.03.02A7.45 7.45 0 0 0 .25 7.75a7.5 7.5 0 1 0 7.5-7.5zm-6.29 7.5c0-1.43.48-2.75 1.29-3.81l8.81 8.81a6.3 6.3 0 0 1-10.1-5zm10.98 4.17L3.58 3.06a6.3 6.3 0 0 1 8.86 8.86z'
                        />
                      </svg>
                    </button>

                    <Tooltip
                      title="Дублировать выходной каждую неделю на протяжении 3 месяцев"
                      position="top"
                      trigger="mouseenter"
                    >
                      <button
                        className='duplicate-button'
                        onClick={() => handleWeekendDuplicate(weekend.id)}
                      >
                        Дублировать
                      </button>
                    </Tooltip>
                  </>)}
              </Observer>)}
          </div>))}
      </div>
      <br />
      <br />
      <Observer>
        {() => (<div className='picker-wrapper'>
            Добавить выходной:
            <br />
            <SingleDatePicker
              block
              isOutsideRange={() => false}
              placeholder='Виберите дату'
              focused={isDatePickerOpen}
              date={selectedDate}
              onDateChange={onDateChange}
              onFocusChange={() => setDatePickerOpen(!isDatePickerOpen)}
            />
          </div>)}
      </Observer>
      <LaddaButton
        className='main-form__submit'
        type='submit'
        data-test-id='submitButton'
        data-color='#eee'
        data-size={XL}
        data-style={SLIDE_UP}
        data-spinner-size={30}
        data-spinner-color='#ddd'
        data-spinner-lines={12}
        onClick={handleWeekendAdd}
      >
        Добавить выходной
      </LaddaButton>
    </>);
};

export default StaffWeekend;